var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSecurityPana(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.86,216.43s-8.35-.61-7.58,18.13S62,263.28,62,263.28s-.25,4.15-3.46,3.34-9.28-4.86-12.26-1.84-2,7.94,2.11,13.61S61,296.79,61.79,297.94s1.05,3.26-1.23,3.06-17.67-5.43-19.71,2,12,21.34,13.52,22.89,1.58,2.53,1,3.46-5.62-1.3-10.06-2.61-9.81-2-10.63,2.36S40,346.41,63.2,359.94l11.14,5.56,10.55-6.73c21.71-15.78,26.58-29.21,25.33-33.5s-6.53-3-10.82-1.29-9.05,4.48-9.75,3.61-.72-1.85.63-3.55,13.93-16.92,11.16-24.13-17.57-.48-19.82-.05-2.16-1.71-1.52-2.91,7.88-14.76,11.41-20.8,4.14-10.94.74-13.75-8.89,1.92-12,3.05-3.78-3-3.78-3,.9-10.12-.21-28.84-9.56-17.21-9.56-17.21",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.52,233.21s0,.13,0,.39.05.66.08,1.15c.07,1,.18,2.52.3,4.42.26,3.85.59,9.41,1,16.28.76,13.75,1.66,32.76,2.57,53.75s1.77,40,2.45,53.76c.35,6.86.63,12.42.83,16.29.1,1.91.17,3.39.22,4.43,0,.49,0,.87.05,1.15a3.81,3.81,0,0,1,0,.39s0-.13-.05-.39,0-.66-.08-1.15c-.07-1-.18-2.52-.3-4.42-.26-3.84-.59-9.41-1-16.28-.76-13.75-1.66-32.76-2.57-53.76s-1.77-40-2.45-53.75c-.35-6.86-.63-12.42-.83-16.29-.1-1.91-.17-3.39-.22-4.43,0-.49,0-.87,0-1.15A3.81,3.81,0,0,1,67.52,233.21Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.47,270.78a3.25,3.25,0,0,1,.7.57c.43.39,1,1,1.77,1.7,1.47,1.46,3.45,3.53,5.59,5.85l5.45,6,1.66,1.8a4.18,4.18,0,0,1,.58.69,3.56,3.56,0,0,1-.7-.57c-.43-.39-1-1-1.76-1.71-1.46-1.47-3.41-3.56-5.55-5.88l-5.49-5.93-1.67-1.79A4.18,4.18,0,0,1,54.47,270.78Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.33,287c-.09-.09,4-4.36,9.1-9.54s9.33-9.32,9.41-9.24-4,4.36-9.11,9.54S71.41,287.07,71.33,287Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.28,319.29a3.55,3.55,0,0,1,.78-.49l2.18-1.23c1.84-1,4.37-2.47,7.11-4.15s5.18-3.29,6.94-4.46l2.08-1.39a4.24,4.24,0,0,1,.79-.47s-.23.24-.69.61-1.15.88-2,1.5c-1.71,1.24-4.13,2.89-6.88,4.57s-5.32,3.09-7.2,4.06c-.94.48-1.71.86-2.25,1.1A3.58,3.58,0,0,1,71.28,319.29Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.81,308a2.76,2.76,0,0,1,.77.36c.48.25,1.18.64,2,1.12,1.7,1,4,2.32,6.59,3.84s4.86,2.93,6.52,4c.83.51,1.5.93,2,1.24a3.38,3.38,0,0,1,.69.5,2.92,2.92,0,0,1-.77-.36l-2-1.12c-1.7-1-4-2.33-6.59-3.85s-4.86-2.92-6.52-3.95c-.83-.52-1.5-.94-2-1.24A3.81,3.81,0,0,1,52.81,308Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.15,336.5a5,5,0,0,1,1,.47l2.59,1.44c2.18,1.22,5.18,2.94,8.48,4.86s6.28,3.67,8.42,5l2.53,1.54a5.62,5.62,0,0,1,.89.62,5,5,0,0,1-1-.47l-2.59-1.43c-2.18-1.23-5.18-2.94-8.48-4.86s-6.28-3.68-8.42-5L50,337.12A4.9,4.9,0,0,1,49.15,336.5Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.56,349.91a6.2,6.2,0,0,1,1-.65l2.71-1.65c2.29-1.39,5.44-3.33,8.86-5.56s6.48-4.32,8.67-5.85l2.61-1.81a6.17,6.17,0,0,1,1-.63,7.43,7.43,0,0,1-.89.76c-.59.47-1.45,1.12-2.53,1.92-2.15,1.6-5.18,3.74-8.61,6s-6.61,4.13-8.94,5.46c-1.17.66-2.12,1.19-2.78,1.53A5.89,5.89,0,0,1,72.56,349.91Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "89.32 369.15 58.48 369.15 68.54 445.35 79.25 445.35 89.32 369.15",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.08,378.52s0,.1.16.27a2,2,0,0,0,.75.53,3.73,3.73,0,0,0,3.25-.4c1.25-.69,2.33-2,4-2.63a8.73,8.73,0,0,1,5.68.11A24.19,24.19,0,0,1,79.2,379a36.43,36.43,0,0,0,4.29,2.3,11.94,11.94,0,0,0,3.17.92,7,7,0,0,0,.89.06c.21,0,.32,0,.32,0a15.76,15.76,0,0,1-4.23-1.27,40.42,40.42,0,0,1-4.2-2.38,23,23,0,0,0-5.38-2.64,9.09,9.09,0,0,0-6-.07,7.75,7.75,0,0,0-2.25,1.4,16.88,16.88,0,0,1-1.77,1.36,3.65,3.65,0,0,1-3,.53A3.37,3.37,0,0,1,60.08,378.52Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2,392.55s.25-.31.73-.82a6.86,6.86,0,0,1,2.46-1.56,11.14,11.14,0,0,1,4.29-.65,46.28,46.28,0,0,1,5.37.73,18,18,0,0,0,5.49.23,15,15,0,0,0,4.33-1.23,13.57,13.57,0,0,0,2.6-1.55,3.45,3.45,0,0,0,.82-.74,27.82,27.82,0,0,1-3.56,2,15.57,15.57,0,0,1-4.24,1.1,18.64,18.64,0,0,1-5.36-.26,39.64,39.64,0,0,0-5.43-.7,10.79,10.79,0,0,0-4.44.78,6.38,6.38,0,0,0-2.47,1.76,4,4,0,0,0-.47.68A.86.86,0,0,0,61.2,392.55Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.83,400.06a3,3,0,0,0-.85-.44,9.08,9.08,0,0,0-2.56-.55,17.12,17.12,0,0,0-3.86.22c-1.44.24-3,.63-4.6,1a19.61,19.61,0,0,1-4.6.52,10,10,0,0,1-3.64-.79A8.44,8.44,0,0,1,63,397.94a2.32,2.32,0,0,0,.52.8,6.36,6.36,0,0,0,2.1,1.58,9.89,9.89,0,0,0,3.77.93,18.31,18.31,0,0,0,4.72-.49c1.64-.35,3.17-.76,4.57-1a17.62,17.62,0,0,1,3.77-.32A14.32,14.32,0,0,1,85.83,400.06Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.93,410.63a4.93,4.93,0,0,1,3-.3,14.72,14.72,0,0,1,3.14,1.17,12,12,0,0,0,4.06,1.12,12.22,12.22,0,0,0,7.38-1.71,10.82,10.82,0,0,0,1.84-1.41c.37-.4.56-.63.54-.66a26.49,26.49,0,0,1-2.56,1.76,12.66,12.66,0,0,1-7.15,1.52C71.25,412,69,410.21,67,410a4.52,4.52,0,0,0-2.32.2C64.13,410.38,63.91,410.61,63.93,410.63Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.65,425.26a6,6,0,0,0,2.57-.52c1.55-.51,3.47-1.7,5.71-2.59a9.37,9.37,0,0,1,3.28-.69,6.18,6.18,0,0,1,2.63.6,5.85,5.85,0,0,1,1.91,1.65,1.41,1.41,0,0,0-.3-.65A4.17,4.17,0,0,0,80,421.75a6,6,0,0,0-2.8-.75,9.1,9.1,0,0,0-3.46.68c-2.32.92-4.18,2.15-5.66,2.73S65.64,425.18,65.65,425.26Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.16,432.06a7.1,7.1,0,0,0,2,.63,34.6,34.6,0,0,0,4.88.83,35.06,35.06,0,0,0,5,.14,7.51,7.51,0,0,0,2-.24c0-.15-3.12,0-6.94-.4S67.2,431.91,67.16,432.06Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M692.18,54.18,635.41,33.8,579.18,53.91C572,57.3,565.71,59.33,565.71,66V99.31a125.87,125.87,0,0,0,18.52,66.26A115.3,115.3,0,0,0,636,211.25c23-7.46,40.14-27.37,50.62-44.39a125.73,125.73,0,0,0,18.53-66.25V70.67C705.11,61.13,700.05,56.48,692.18,54.18Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636,191.93c-19.78-8.81-32.63-23-40.93-36.44a99.54,99.54,0,0,1-14.65-52.42V79.72c0-5.29,3.19-10.25,9.53-13.21l45.51-17V33.8L579.18,53.91c-5.9,2.58-13.47,5.42-13.47,12.11V99.31a125.87,125.87,0,0,0,18.52,66.26A115.3,115.3,0,0,0,636,211.25Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M636,211.25a68.42,68.42,0,0,0,11.15-4.78,100.33,100.33,0,0,0,23.61-18.57,127.31,127.31,0,0,0,16.42-22.06,121.17,121.17,0,0,0,18-66.89l0-27.49c0-13.69-7-14.7-13-17.28L635.41,33.8V49.5l46,17.29c6.34,3,9.53,7.91,9.53,13.2v23.35a99.53,99.53,0,0,1-14.66,52.42C668,169.23,655.74,183.12,636,191.93Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M650.47,101.57l.06-4.49a14.74,14.74,0,0,0-29.48,0l-.06,4.57a8.25,8.25,0,0,0-7,8.15v26.5a8.25,8.25,0,0,0,8.25,8.25h27.52a8.25,8.25,0,0,0,8.25-8.25v-26.5A8.25,8.25,0,0,0,650.47,101.57Zm-10.75,28.12h-7.19l1.12-5.2a4.38,4.38,0,1,1,4.76-.08Zm7.57-28.16H624.17l.06-4.45a11.57,11.57,0,0,1,23.13,0Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M589.58,101.25a18.4,18.4,0,0,1-.85-4.61,79.47,79.47,0,0,1-.46-11.31c.06-2.21.21-4.31.41-6.22a13.17,13.17,0,0,1,1.27-5,5.83,5.83,0,0,1,2.48-2.5c.77-.36,1.25-.34,1.26-.29a6.48,6.48,0,0,0-3.12,3.1,13.84,13.84,0,0,0-1,4.8c-.15,1.89-.27,4-.33,6.16-.13,4.38,0,8.35.17,11.22S589.73,101.23,589.58,101.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.42,115.74c-.28,0-.53-1.36-.56-3.06s.16-3.07.43-3.07.53,1.36.56,3S590.69,115.73,590.42,115.74Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M717.62,445.41c0,.15-152.65.26-340.9.26s-340.92-.11-340.92-.26,152.61-.26,340.92-.26S717.62,445.27,717.62,445.41Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M596,62.06H162A13.55,13.55,0,0,0,148.48,75.6V382.09A13.55,13.55,0,0,0,162,395.64H328.57s10.59,32.76-22.25,49.71H462.05S425,432.64,434.5,395.64H596a13.55,13.55,0,0,0,13.54-13.55V75.6A13.54,13.54,0,0,0,596,62.06Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M384.79,363.4c5.9,8.44-3.34,17.68-11.78,11.78a2.94,2.94,0,0,1-.72-.73c-5.89-8.43,3.34-17.66,11.77-11.77A3.12,3.12,0,0,1,384.79,363.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.65,67.67H592.33a9.7,9.7,0,0,1,9.7,9.7v262.2a0,0,0,0,1,0,0H156a0,0,0,0,1,0,0V77.37A9.7,9.7,0,0,1,165.65,67.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.11,67.67H594.51A7.52,7.52,0,0,1,602,75.19V90.26a0,0,0,0,1,0,0H156a0,0,0,0,1,0,0V76.82A9.15,9.15,0,0,1,165.11,67.67Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 170.16,
    cy: 79.44,
    r: 3.13,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 179.5,
    cy: 79.44,
    r: 3.13,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 188.38,
    cy: 79.44,
    r: 3.13,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M518.38,395.68c0,.15-61.75.26-137.9.26s-137.92-.11-137.92-.26,61.74-.26,137.92-.26S518.38,395.54,518.38,395.68Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M447.89,128.52l-68-25.05-67.35,24.72c-8.6,4.16-16.14,6.66-16.14,14.87V184a157.64,157.64,0,0,0,22.19,81.42c12.56,20.91,32,42.44,62,56.13,27.53-9.17,48.08-33.62,60.64-54.54a157.58,157.58,0,0,0,22.19-81.41V148.78C463.37,137.06,457.32,131.34,447.89,128.52Z",
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.8
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M447.89,128.52l-68-25.05-67.35,24.72c-8.6,4.16-16.14,6.66-16.14,14.87V184a157.64,157.64,0,0,0,22.19,81.42c12.56,20.91,32,42.44,62,56.13,27.53-9.17,48.08-33.62,60.64-54.54a157.58,157.58,0,0,0,22.19-81.41V148.78C463.37,137.06,457.32,131.34,447.89,128.52Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M421.41,232.08h-12.5v-68a29,29,0,1,0-58.07,0v68h-12.5v-68a41.54,41.54,0,1,1,83.07,0Z",
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M421.41,232.08h-12.5v-68a29,29,0,1,0-58.07,0v68h-12.5v-68a41.54,41.54,0,1,1,83.07,0Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 323.9,
    y: 201.82,
    width: 111.95,
    height: 71.82,
    rx: 5.81,
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M389.23,228.38a9.36,9.36,0,1,0-11.91,9v14h5.11v-14A9.33,9.33,0,0,0,389.23,228.38Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M329.87,266.83c-.26,0-.46-12-.46-26.75s.2-26.75.46-26.75.47,12,.47,26.75S330.13,266.83,329.87,266.83Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.55,240.37s-.44-.14-1.1-.62a11.23,11.23,0,0,1-2.41-2.46,13.11,13.11,0,0,1,4.66-19.68A11.5,11.5,0,0,1,377,216.5a3,3,0,0,1,1.26-.07c0,.18-1.77.35-4.2,1.76a13,13,0,0,0-4.43,18.73A27.68,27.68,0,0,0,372.55,240.37Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464,305.66s.27-.38.81-1.09l.45-.6c.16-.23.3-.5.46-.79a11.83,11.83,0,0,0,1-2.05c.16-.41.35-.83.51-1.29s.27-1,.41-1.48a9.26,9.26,0,0,0,.34-1.65,17,17,0,0,0,.26-1.82,34.9,34.9,0,0,0-.4-8.77c-1-6.57-3.8-14.29-8.06-22.69a176.78,176.78,0,0,0-17.3-26.9,275.43,275.43,0,0,0-25.8-29,315.13,315.13,0,0,0-33.86-28.91c-6.33-4.64-13-9.15-20-13.4a194.88,194.88,0,0,0-22.24-11.66,104,104,0,0,0-24.74-7.75,43.91,43.91,0,0,0-13.2-.33,24.89,24.89,0,0,0-6.37,1.85A15.88,15.88,0,0,0,287.6,157a24.62,24.62,0,0,0-1.11,6.54,43.74,43.74,0,0,0,1.81,13.08,103.75,103.75,0,0,0,10.52,23.7,194.19,194.19,0,0,0,14.12,20.78c5,6.5,10.26,12.61,15.59,18.36a315.2,315.2,0,0,0,32.58,30.37,276.85,276.85,0,0,0,31.73,22.33,176.83,176.83,0,0,0,28.69,14.12c8.83,3.28,16.82,5.16,23.46,5.42a34.1,34.1,0,0,0,8.76-.6,17.59,17.59,0,0,0,1.77-.45,11.69,11.69,0,0,0,1.61-.53l1.42-.58c.44-.21.84-.45,1.22-.65a12.92,12.92,0,0,0,1.93-1.26c.26-.2.52-.36.73-.54l.54-.52,1-.93-.95,1-.54.54c-.21.18-.46.35-.73.56a13,13,0,0,1-1.92,1.28c-.38.21-.78.45-1.22.67l-1.43.59a10.13,10.13,0,0,1-1.61.54,17.74,17.74,0,0,1-1.78.48,34.67,34.67,0,0,1-8.8.65c-6.67-.23-14.69-2.1-23.55-5.35a176.29,176.29,0,0,1-28.78-14.09,272.57,272.57,0,0,1-31.81-22.31,314.62,314.62,0,0,1-32.66-30.37c-5.35-5.76-10.6-11.88-15.63-18.39a195.57,195.57,0,0,1-14.17-20.82,104.67,104.67,0,0,1-10.58-23.82A44.31,44.31,0,0,1,286,163.54a24.76,24.76,0,0,1,1.14-6.69,16.34,16.34,0,0,1,8.91-10,24.9,24.9,0,0,1,6.51-1.89,44,44,0,0,1,13.36.33,103.89,103.89,0,0,1,24.86,7.8A191.79,191.79,0,0,1,363,164.82c7,4.26,13.72,8.78,20,13.43a316.11,316.11,0,0,1,33.89,29,275.54,275.54,0,0,1,25.78,29.06,176.7,176.7,0,0,1,17.27,27c4.24,8.43,7,16.19,8,22.78a34.62,34.62,0,0,1,.35,8.82,16.79,16.79,0,0,1-.26,1.83,11.56,11.56,0,0,1-.36,1.66c-.15.52-.29,1-.42,1.49s-.37.88-.53,1.29a11.43,11.43,0,0,1-1.06,2.05c-.17.29-.31.56-.47.79l-.47.59C464.25,305.31,464,305.66,464,305.66Z",
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496,228.39s-.05-.46-.12-1.35q0-.34-.06-.75c0-.28-.12-.57-.18-.9a12.41,12.41,0,0,0-.6-2.22c-.15-.41-.29-.85-.47-1.3s-.45-.89-.69-1.38A10.48,10.48,0,0,0,493,219c-.33-.48-.61-1-1-1.52a34.56,34.56,0,0,0-6.14-6.28c-5.13-4.22-12.35-8.14-21.11-11.57a177.27,177.27,0,0,0-30.82-8.56,275.39,275.39,0,0,0-38.54-4.45,316,316,0,0,0-44.52,1c-7.81.74-15.79,1.82-23.86,3.33a194.1,194.1,0,0,0-24.36,6.1A104.19,104.19,0,0,0,279,207.73,44,44,0,0,0,269,216.27a24.46,24.46,0,0,0-3.52,5.62,15.87,15.87,0,0,0,0,13,24.8,24.8,0,0,0,3.52,5.62A43.73,43.73,0,0,0,279,249a104,104,0,0,0,23.64,10.69,193.24,193.24,0,0,0,24.36,6.1c8.07,1.52,16.05,2.59,23.86,3.33a314.48,314.48,0,0,0,44.52,1,275.21,275.21,0,0,0,38.54-4.45,176.77,176.77,0,0,0,30.82-8.56c8.77-3.43,16-7.35,21.11-11.57a34.23,34.23,0,0,0,6.14-6.28,16.82,16.82,0,0,0,1-1.52,9.93,9.93,0,0,0,.84-1.46l.69-1.38c.18-.45.32-.89.47-1.3a12.41,12.41,0,0,0,.6-2.22c.06-.32.14-.62.18-.89s0-.53.06-.75c.07-.9.12-1.35.12-1.35s0,.46-.07,1.35c0,.23,0,.48,0,.76s-.11.57-.17.9a12.51,12.51,0,0,1-.58,2.23c-.15.42-.28.86-.47,1.32l-.67,1.39a10.42,10.42,0,0,1-.84,1.47c-.33.49-.61,1.05-1,1.55A34.31,34.31,0,0,1,486,245.7c-5.13,4.26-12.36,8.22-21.13,11.68A177.18,177.18,0,0,1,434,266a275.45,275.45,0,0,1-38.59,4.53,315.25,315.25,0,0,1-44.59-.93c-7.82-.74-15.81-1.81-23.91-3.32a195,195,0,0,1-24.42-6.1,104.49,104.49,0,0,1-23.76-10.74,44.65,44.65,0,0,1-10.18-8.65,25,25,0,0,1-3.6-5.76,16.39,16.39,0,0,1,0-13.37,25.28,25.28,0,0,1,3.6-5.75,44.19,44.19,0,0,1,10.19-8.64,104,104,0,0,1,23.75-10.73,193.3,193.3,0,0,1,24.42-6.11c8.09-1.51,16.08-2.58,23.9-3.32a315.19,315.19,0,0,1,44.59-.92A274,274,0,0,1,434,190.74a176.81,176.81,0,0,1,30.85,8.65c8.78,3.47,16,7.42,21.14,11.68a34.66,34.66,0,0,1,6.13,6.35,17.06,17.06,0,0,1,1,1.54,11.68,11.68,0,0,1,.84,1.47l.67,1.4c.19.45.32.9.47,1.31a12.38,12.38,0,0,1,.58,2.24c.06.32.13.62.17.9s0,.53,0,.75C496,227.93,496,228.39,496,228.39Z",
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.56,132.2s-.4-.24-1.14-.73l-.63-.41c-.24-.14-.53-.26-.82-.41a12.68,12.68,0,0,0-2.12-.88c-.42-.13-.85-.3-1.32-.43L446,129a10.68,10.68,0,0,0-1.67-.23c-.59,0-1.19-.15-1.83-.13a35,35,0,0,0-8.73,1c-6.47,1.46-14,4.77-22.07,9.6a176.5,176.5,0,0,0-25.65,19.11,275.11,275.11,0,0,0-27.13,27.73,315.8,315.8,0,0,0-26.51,35.78c-4.2,6.63-8.24,13.59-12,20.9a195.2,195.2,0,0,0-10.1,23,103.89,103.89,0,0,0-6,25.22,43.62,43.62,0,0,0,.59,13.19,24.4,24.4,0,0,0,2.28,6.23,15.85,15.85,0,0,0,10.24,7.95,24.43,24.43,0,0,0,6.6.66,43.73,43.73,0,0,0,12.92-2.71,104,104,0,0,0,22.93-12.13,193.6,193.6,0,0,0,19.75-15.52c6.14-5.45,11.88-11.1,17.25-16.82a314.79,314.79,0,0,0,28-34.59A275.18,275.18,0,0,0,445,204.08a177.39,177.39,0,0,0,12.11-29.6c2.66-9,4-17.13,3.79-23.77a34.21,34.21,0,0,0-1.2-8.7,16.89,16.89,0,0,0-.58-1.74,10.57,10.57,0,0,0-.63-1.56c-.24-.48-.46-1-.67-1.38s-.51-.81-.74-1.17a12.39,12.39,0,0,0-1.39-1.84c-.21-.25-.4-.49-.59-.69l-.56-.51c-.66-.6-1-.92-1-.92l1,.88.56.5c.2.2.39.44.61.69a11.19,11.19,0,0,1,1.41,1.83c.24.37.51.75.76,1.17l.68,1.38a10.13,10.13,0,0,1,.66,1.57c.18.56.45,1.12.59,1.75a34.74,34.74,0,0,1,1.26,8.73c.23,6.67-1.08,14.8-3.72,23.86a176.7,176.7,0,0,1-12.06,29.69,275.39,275.39,0,0,1-20.07,33.27,315.29,315.29,0,0,1-28,34.67c-5.38,5.74-11.12,11.4-17.27,16.87a193.78,193.78,0,0,1-19.8,15.56,103.84,103.84,0,0,1-23,12.19A43.86,43.86,0,0,1,324,319.56a25.23,25.23,0,0,1-6.75-.68,16.37,16.37,0,0,1-10.57-8.2,24.88,24.88,0,0,1-2.33-6.37,44.34,44.34,0,0,1-.6-13.34,104.41,104.41,0,0,1,6.07-25.35,194.82,194.82,0,0,1,10.14-23c3.76-7.32,7.81-14.29,12-20.93a315.46,315.46,0,0,1,26.58-35.8,275.49,275.49,0,0,1,27.22-27.73A176,176,0,0,1,411.57,139c8.12-4.82,15.67-8.11,22.18-9.55a34.09,34.09,0,0,1,8.77-1,17.63,17.63,0,0,1,1.84.14,10.78,10.78,0,0,1,1.68.24l1.52.32c.47.14.9.3,1.32.44a11.91,11.91,0,0,1,2.12.91c.3.15.58.28.82.42l.62.42C453.19,131.93,453.56,132.2,453.56,132.2Z",
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 259.47,
    cy: 279.35,
    r: 4.31,
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.78,142.7a4.31,4.31,0,1,1-4.31-4.32A4.31,4.31,0,0,1,505.78,142.7Z",
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.74,290.48a1.1,1.1,0,1,1-1.09-1.1A1.1,1.1,0,0,1,289.74,290.48Z",
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.13,169.66a1.1,1.1,0,1,1-1.1-1.1A1.1,1.1,0,0,1,313.13,169.66Z",
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M484.12,228.39a1.1,1.1,0,1,1-1.09-1.1A1.09,1.09,0,0,1,484.12,228.39Z",
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.35,177.3a1.1,1.1,0,1,1-1.09-1.09A1.09,1.09,0,0,1,499.35,177.3Z",
    style: {
      fill: "#6C2BD9"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M675.52,340.9a37.41,37.41,0,0,1,16-5.49c2.6-.27,5.45-.19,7.55,1.39a1.55,1.55,0,0,1,.77,1.38,1.66,1.66,0,0,1-.74.94c-6.49,4.95-16.31,5.58-23.54,1.78",
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.93,340.45a78.11,78.11,0,0,0,10.31-9.07,26.12,26.12,0,0,0,6.46-11.95,4.83,4.83,0,0,0-.51-4c-8.22,6.42-14.67,14.72-16.26,25",
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M675.61,340.84a37.28,37.28,0,0,0-.2-13.53,18.29,18.29,0,0,0-7.2-11.17c-1.42,3.32-.81,7.14.19,10.61a51.53,51.53,0,0,0,7.14,15.05",
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.55,355.27c4.89.6,9.15,3.17,12.8,6.48a24.23,24.23,0,0,1,7.32,12.56c-4.8-.29-8.86-3.67-11.82-7.47s-5-7.95-8.23-11.49",
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.8,357.58a31.58,31.58,0,0,0-3.64-29.86c-2.79,9.91-1.76,21.1,3.64,29.86",
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.16,370.25A22.82,22.82,0,0,1,677,382.81c.27.54.51,1.23.15,1.71a1.63,1.63,0,0,1-1.45.43c-4.3-.28-8.11-2.87-11.25-5.81s-5.89-6.35-9.36-8.9",
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.5,369.56a40.67,40.67,0,0,0,.41-22.7c-.8-2.93-2.15-6-4.85-7.37a.94.94,0,0,0-.74-.13,1,1,0,0,0-.47.54,13.68,13.68,0,0,0-1.14,6.51,41,41,0,0,0,1,6.6c.85,4,1.3,8.36,3.51,11.83a24.22,24.22,0,0,1,1.41,2.6c.42.89.42,1.2.8,1.9",
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.33,373.76c2.09-7.94-.12-17.56-5.13-24.07-.36-.48-.85-1-1.45-.94-.93.09-1.16,1.31-1.12,2.24a43.49,43.49,0,0,0,7.7,22.77",
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.79,375.49c-9.64,2.51-20.7.07-28.72-5.84a23.23,23.23,0,0,1,15.55-1.91c5.19,1.19,9.94,3.52,13.17,7.75",
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M622.65,370.21c-5.4-8.81-15.75-14.56-26.07-15.08,1.19,4.2,4.64,7.46,8.53,9.43s8.23,2.83,12.51,3.66c1.67.32,4,.68,5,2",
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M626.8,344.56c-1.46-5-2.94-10.06-3.34-15.27s.34-10.64,3-15.1c5,9.76,5.56,21.17.45,30.89",
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M609.81,336c-5.9-10.73-17.94-19.29-30.12-20.49,4.7,11.7,17.52,20.74,30.12,20.49",
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.52,338.08c-8.8,1.34-16.29,7-24.52,10.36a11,11,0,0,1-5.54,1.07,4.34,4.34,0,0,1-2.72-7.68,11.78,11.78,0,0,1,4-2.44c9-3.73,18.56-3.82,28-1.56",
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M618.62,344.25c-2,.57-2.68,1.6-4.26,2.94a45.76,45.76,0,0,1-18.59,9.55c-.71.18-1.64.25-2-.39s.08-1.24.48-1.74A25.55,25.55,0,0,1,605.49,347c4.29-1.6,8-3.52,13.13-3.11",
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.36,307a35.17,35.17,0,0,1-27,9.18,1.81,1.81,0,0,1-1.22-.44c-.68-.74.13-1.88.92-2.49,7.93-6.19,17.54-8.75,27.28-6.25",
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.55,304.48a37.59,37.59,0,0,0-33.66-5.55c4.24,4.17,10.12,6.42,16,7a50.61,50.61,0,0,0,17.62-1.49",
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.26,287.35c.78-7.91.27-14.16.82-22.12,0-.63.18-1.4.77-1.63.83-.31,1.52.7,1.79,1.55a25.36,25.36,0,0,1-3.37,22",
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.83,288.23a46.43,46.43,0,0,1-13.12-12.75c-2.59-3.54-4.77-7.79-4.18-12.14A12.6,12.6,0,0,1,613,268a26.46,26.46,0,0,1,4.82,9.7c1.05,3.48,1.78,7.06,3,10.49",
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.94,284.65a106,106,0,0,1-32.27-19c3.85-1.55,8.27-.63,12.12.93,8.81,3.55,16,9.55,20.32,18",
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M617.2,292.56c-6,.65-12,1.07-17.92.09s-11.3-3.28-16.73-5.56a1.93,1.93,0,0,1-1.13-.87,1.3,1.3,0,0,1,.4-1.43,3.69,3.69,0,0,1,1.43-.67c5.9-1.65,12.27-.87,18.08,1.08a83.74,83.74,0,0,1,15.87,7.36",
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M651.22,307.24c4.07-8.2,3.8-17.77.29-26.23-2.47,3.77-2.77,8.56-2.32,13s1.82,9.1,1.9,13.6",
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.46,299.06a36.57,36.57,0,0,1,27.19,11.58c-5.07.79-10.28-.51-14.89-2.76s-8.7-5.41-12.76-8.54",
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M678.38,295.4c5-.4,9.74-1,14.51.45s9.12,4.78,11.06,9.38a26.21,26.21,0,0,1-13.6-2.57,77.75,77.75,0,0,1-12-7.26",
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.21,295.57c4.47-2.93,9-5.91,14.25-7.12s11.23-.31,14.86,3.61c-4.21,2.47-9.32,2.76-14.2,2.75s-10.86-.06-15.47,1.57",
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.19,295.81c7.63-7.5,10.53-21,7.45-31.22a47.53,47.53,0,0,0-7.45,31.22",
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.19,274.56c-1.44-3.34-2.45-6.86-3.74-10.26a29.62,29.62,0,0,0-5.34-9.47,14,14,0,0,0-9.46-4.9A38.12,38.12,0,0,0,641,274.62",
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645,279c2.38-3.28,5.14-7.73,8.37-10.18s7.44-3.93,11.38-3A26.52,26.52,0,0,1,645,279",
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M644.23,274.84a57.22,57.22,0,0,0,3.77-12.2c.63-4.22.24-8.72-1.91-12.4-4.19,7.92-5.54,16.42-2.07,24.69",
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.15,250.24c-2.37-7.86-9.56-13.64-17.33-16.3a6.49,6.49,0,0,0-3-.45,2.65,2.65,0,0,0-2.24,1.87c-.28,1.33.82,2.53,1.86,3.42a59.21,59.21,0,0,0,20.75,11.46",
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.07,243.81c-.31-5.06-.62-10.2-2.27-15s-4.82-9.3-9.44-11.4c-.78,5.12,1.47,10.21,4.19,14.61s6,8.55,7.64,13.46",
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.19,247.3c2-5.73,2.17-13,5.59-18,2.4-3.49,6.24-5.86,8.3-9.55a14.55,14.55,0,0,1-.48,10.84,31.69,31.69,0,0,1-6.34,9.08c-2.54,2.71-4.71,4.74-7.07,7.61",
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.15,415.86c.15,0,.29-38.18.3-85.27s-.11-85.29-.26-85.29-.28,38.18-.29,85.29S641,415.86,641.15,415.86Z",
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M607.78,301.48a7.92,7.92,0,0,0,1.44.54l3.95,1.33c3.33,1.14,7.91,2.78,12.88,4.82s9.55,3.82,12.19,6.11a8.91,8.91,0,0,1,2.45,3.24c.38.9.45,1.45.5,1.44a1.12,1.12,0,0,0,0-.4,6,6,0,0,0-.28-1.12A8.53,8.53,0,0,0,638.5,314a21.43,21.43,0,0,0-5.29-3.29c-2.12-1-4.46-2-7-3-5-2-9.59-3.63-13-4.68-1.68-.52-3.06-.91-4-1.16A9.35,9.35,0,0,0,607.78,301.48Z",
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M596.85,274.62s.12.16.4.43l1.22,1.15,4.58,4.15,15.22,13.56c6,5.29,11.08,10.34,14.64,14.15,1.78,1.9,3.19,3.47,4.14,4.57l1.11,1.27a3.7,3.7,0,0,0,.41.42s-.09-.18-.32-.49-.57-.77-1-1.33c-.91-1.15-2.27-2.77-4-4.71a193.62,193.62,0,0,0-14.56-14.29c-6-5.28-11.39-10-15.33-13.44l-4.69-4-1.3-1.08C597,274.72,596.86,274.6,596.85,274.62Z",
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.69,299.29c.15-.07-1.09-2.94-2.32-6.56s-1.84-6.69-2-6.66a22.64,22.64,0,0,0,1.47,6.83,43.12,43.12,0,0,0,1.85,4.59A6.93,6.93,0,0,0,624.69,299.29Z",
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.12,322.4a7.52,7.52,0,0,0,.91-1.06l2.35-3c2-2.55,4.69-6.07,7.75-9.91s5.86-7.3,7.89-9.8c1-1.19,1.77-2.18,2.4-3a6.93,6.93,0,0,0,.83-1.13,6.48,6.48,0,0,0-1,1c-.61.66-1.48,1.64-2.54,2.86-2.11,2.43-5,5.85-8,9.7s-5.74,7.41-7.63,10c-1,1.31-1.7,2.37-2.21,3.12A6.45,6.45,0,0,0,641.12,322.4Z",
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.43,313a13.45,13.45,0,0,0,3.07-5.74,16.31,16.31,0,0,0,.69-5.79l-.24,0c.11.44.19.68.23.67s.05-.25,0-.71l-.24,0a26.69,26.69,0,0,1-1,5.63A42.42,42.42,0,0,1,648.43,313Z",
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M657.88,301.12a10.24,10.24,0,0,1,2.14-1.24,14.4,14.4,0,0,1,5.94-.47,36.5,36.5,0,0,1,6,1,19.43,19.43,0,0,0,2.47.6,8.31,8.31,0,0,0-2.36-1,27.65,27.65,0,0,0-6-1.14,13,13,0,0,0-6.13.66A3.76,3.76,0,0,0,657.88,301.12Z",
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M660.12,298.25c0,.08,1.24-.5,3.28-1.2a33.11,33.11,0,0,1,16.52-1.26c2.11.38,3.39.78,3.42.68a3.76,3.76,0,0,0-.87-.37,20.61,20.61,0,0,0-2.48-.69,29,29,0,0,0-8.46-.59,29.34,29.34,0,0,0-8.27,1.86,19.94,19.94,0,0,0-2.34,1.07C660.39,298,660.1,298.21,660.12,298.25Z",
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.19,286.07a66.6,66.6,0,0,0,2.39-8.31,68.16,68.16,0,0,0,1.86-8.44,66.6,66.6,0,0,0-2.39,8.31A66,66,0,0,0,641.19,286.07Z",
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641,286.07a38.66,38.66,0,0,1,2.65-5,21.82,21.82,0,0,1,3.9-4,3.6,3.6,0,0,0-1.51.78,12.08,12.08,0,0,0-2.84,2.93A10.89,10.89,0,0,0,641,286.07Z",
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M641.15,395.51c.06,0,.17-.92.6-2.54a36.35,36.35,0,0,1,2.56-6.61c2.63-5.4,7.43-12.23,13.53-19.08,3-3.45,6-6.71,8.45-9.83a69.13,69.13,0,0,0,6-8.71,41.43,41.43,0,0,0,3-6.46c.28-.79.49-1.42.6-1.85a3,3,0,0,0,.16-.66s-.33.88-1,2.43a47.45,47.45,0,0,1-3.18,6.35,73.5,73.5,0,0,1-6.1,8.58c-2.5,3.09-5.43,6.33-8.46,9.79-6.12,6.86-10.91,13.79-13.48,19.27a32.57,32.57,0,0,0-2.4,6.72,17.71,17.71,0,0,0-.34,1.92A2.87,2.87,0,0,0,641.15,395.51Z",
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611,361.45a14.72,14.72,0,0,0,1.58.89,34.2,34.2,0,0,1,4.1,2.71,45.81,45.81,0,0,1,5.38,4.91c1.89,2,3.84,4.31,5.82,6.79,4,5,7.69,9.39,9.91,12.91,1.13,1.75,2,3.22,2.49,4.25a13.7,13.7,0,0,0,.87,1.6,1.32,1.32,0,0,0-.14-.45c-.12-.29-.28-.71-.54-1.24a38.43,38.43,0,0,0-2.35-4.36c-2.16-3.61-5.84-8.08-9.81-13-2-2.49-4-4.81-5.88-6.81a43.9,43.9,0,0,0-5.52-4.87,28.57,28.57,0,0,0-4.23-2.58c-.52-.27-.95-.43-1.23-.55S611,361.43,611,361.45Z",
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.41,372.5a23.73,23.73,0,0,0,3.34.48,44.4,44.4,0,0,1,7.92,1.56,24,24,0,0,1,7.09,3.72c1.64,1.27,2.41,2.31,2.49,2.25a3,3,0,0,0-.5-.77A13.18,13.18,0,0,0,629,378a21.49,21.49,0,0,0-7.17-3.94,35.53,35.53,0,0,0-8.05-1.43A18.27,18.27,0,0,0,610.41,372.5Z",
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M630.27,379.3c.18-.1-1.33-2.4-2.5-5.49s-1.35-5.86-1.55-5.83a5.56,5.56,0,0,0,.06,1.79,19.19,19.19,0,0,0,1,4.23,20.64,20.64,0,0,0,1.94,3.87A5.53,5.53,0,0,0,630.27,379.3Z",
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.23,331.79a4,4,0,0,0,.54.28l1.57.71c.69.3,1.52.67,2.46,1.17s2.05,1,3.19,1.68l1.82,1c.64.37,1.26.8,1.93,1.21,1.34.82,2.69,1.82,4.12,2.85a70.74,70.74,0,0,1,15.89,16.44c1,1.47,1.93,2.85,2.7,4.22.39.68.8,1.32,1.15,2l1,1.86c.65,1.17,1.11,2.28,1.56,3.24s.81,1.81,1.08,2.5l.66,1.6a2.31,2.31,0,0,0,.27.54,2.38,2.38,0,0,0-.16-.58l-.57-1.63a25.83,25.83,0,0,0-1-2.55c-.43-1-.87-2.11-1.5-3.3-.31-.6-.62-1.23-.95-1.88s-.74-1.31-1.12-2c-.76-1.39-1.71-2.79-2.68-4.28a68.2,68.2,0,0,0-16-16.56c-1.45-1-2.82-2-4.18-2.82-.67-.41-1.31-.84-2-1.2l-1.85-1c-1.17-.67-2.29-1.15-3.25-1.61a25.23,25.23,0,0,0-2.51-1.08l-1.61-.62A2.06,2.06,0,0,0,601.23,331.79Z",
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.1,347.78a3.85,3.85,0,0,0-1.31-2,8.29,8.29,0,0,0-5.29-2,14.47,14.47,0,0,0-5.56,1.09,8.16,8.16,0,0,0-2.11,1,12.13,12.13,0,0,0,2.23-.65,17,17,0,0,1,5.42-.91,8.59,8.59,0,0,1,5,1.78A15.93,15.93,0,0,1,625.1,347.78Z",
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.66,351.46c.16-.09-1.19-2.06-1.5-4.89a20.13,20.13,0,0,1,.34-5.1,3.35,3.35,0,0,0-.62,1.43,10.15,10.15,0,0,0,.85,7.31A3.44,3.44,0,0,0,628.66,351.46Z",
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.52,401c-.82,14.59-5.22,29.43-12,44.43H626.13c-6.45-14.85-10.55-29.67-11.27-44.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.62,424.59c0,.15,9.69.28,21.63.28s21.63-.13,21.63-.28-9.68-.28-21.63-.28S619.62,424.44,619.62,424.59Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620.28,429.88c0,.15,9.08.27,20.28.27s20.27-.12,20.27-.27-9.07-.28-20.27-.28S620.28,429.72,620.28,429.88Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M655.07,410.56a82.11,82.11,0,0,0,0,13.55,85.14,85.14,0,0,0,0-13.55Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.31,410.56a88,88,0,0,0,0,14,91.27,91.27,0,0,0,0-14Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.51,410.44a94.94,94.94,0,0,0,0,14.31,91.56,91.56,0,0,0,0-14.31Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M615.79,410.56c0,.15,11.36.27,25.37.27s25.36-.12,25.36-.27-11.35-.28-25.36-.28S615.79,410.41,615.79,410.56Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-18"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.63,412.8l-4.75,24.32-9.31,18.14a2.54,2.54,0,0,0,1.26,3.49h0a2.51,2.51,0,0,0,2.32-.16c4.47-2.73,20.86-12.86,21.11-14.66.28-2.08,6.71-25.31,6.71-25.31Z",
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.83,458.75l23.79-16.45-.23,1a3.8,3.8,0,0,1-1.41,2.23C116,447,110.62,451,98.22,458.61a2.53,2.53,0,0,1-2.39.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.34,435.14a1.53,1.53,0,0,0-.84,1.87,1.47,1.47,0,0,0,1.84.85,1.61,1.61,0,0,0,.88-2,1.54,1.54,0,0,0-2-.68",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.68,449.39A7.78,7.78,0,0,0,102,447a7.9,7.9,0,0,0-2.67-1.14c0-.06.34-.18.93-.14a4,4,0,0,1,3.38,2.7C103.79,449,103.74,449.39,103.68,449.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.25,452.25c-.14.08-.75-.87-1.92-1.51a21,21,0,0,0-2.29-.82,2.79,2.79,0,0,1,2.56.35C100.93,451,101.39,452.22,101.25,452.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.8,445.94a26.13,26.13,0,0,0-2.8-2.53,25,25,0,0,0-3.4-1.62,5.59,5.59,0,0,1,3.7,1.17A5.66,5.66,0,0,1,107.8,445.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.86,438.67c-.1.13-1.31-.72-3-1.16s-3.2-.33-3.22-.49a4.82,4.82,0,0,1,3.35,0A4.92,4.92,0,0,1,109.86,438.67Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.44,431.57a12.47,12.47,0,0,0-3.13-1.3,12.16,12.16,0,0,0-3.39.11c0-.06.31-.31.93-.51a5.55,5.55,0,0,1,4.9.9C111.26,431.18,111.48,431.53,111.44,431.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.65,428.93a2.09,2.09,0,0,1,.16-.92,6.69,6.69,0,0,1,1.26-2.24,2.9,2.9,0,0,1,1.5-1.08,1,1,0,0,1,1.08.47,1.65,1.65,0,0,1,.14,1.17A3.58,3.58,0,0,1,109,428.9a4.16,4.16,0,0,1-3.53-3,1.46,1.46,0,0,1,.19-1.19,1,1,0,0,1,1.14-.29,3.59,3.59,0,0,1,1.41,1.18,7.15,7.15,0,0,1,1.24,2.24,2.29,2.29,0,0,1,.19.92,11.52,11.52,0,0,0-1.72-2.91,3.22,3.22,0,0,0-1.26-1,.52.52,0,0,0-.62.16,1,1,0,0,0-.08.79,3.71,3.71,0,0,0,3.09,2.56,3.11,3.11,0,0,0,3.24-2.13,1.21,1.21,0,0,0-.06-.83.54.54,0,0,0-.59-.26,2.5,2.5,0,0,0-1.29.89A9.58,9.58,0,0,0,108.65,428.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.66,414.69l4.05,24.44,8.77,18.41a2.53,2.53,0,0,1-1.35,3.45h0a2.52,2.52,0,0,1-2.31-.23c-4.39-2.86-20.49-13.45-20.68-15.26-.23-2.09-6-25.5-6-25.5Z",
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.13,461l-23.3-17.13.19,1a3.85,3.85,0,0,0,1.35,2.26c1.89,1.53,7.2,5.62,19.37,13.63a2.57,2.57,0,0,0,2.39.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.31,436.8a1.54,1.54,0,0,1,.79,1.89,1.49,1.49,0,0,1-1.87.8,1.61,1.61,0,0,1-.82-2,1.52,1.52,0,0,1,2-.61",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.55,451.41a7.72,7.72,0,0,1,1.78-2.3,7.51,7.51,0,0,1,2.7-1.06c0-.07-.34-.2-.92-.17a4,4,0,0,0-3.46,2.6C193.46,451,193.49,451.4,193.55,451.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.9,454.34c.14.08.77-.85,2-1.45a20.53,20.53,0,0,1,2.32-.76,2.82,2.82,0,0,0-2.57.27C196.26,453.09,195.76,454.3,195.9,454.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.53,447.84a27.38,27.38,0,0,1,2.87-2.45,25.35,25.35,0,0,1,3.45-1.52,6.92,6.92,0,0,0-6.32,4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.68,440.52c.09.13,1.33-.69,3.07-1.08s3.2-.24,3.23-.4a5,5,0,0,0-3.35-.13A4.91,4.91,0,0,0,187.68,440.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.31,433.37a12.39,12.39,0,0,1,3.17-1.2,12.23,12.23,0,0,1,3.38.2c0-.06-.3-.32-.92-.54a5.61,5.61,0,0,0-2.55-.2,5.51,5.51,0,0,0-2.36,1C186.5,433,186.26,433.33,186.31,433.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.18,430.82a2.18,2.18,0,0,0-.15-.93,6.41,6.41,0,0,0-1.18-2.27,2.87,2.87,0,0,0-1.48-1.13,1,1,0,0,0-1.08.44,1.62,1.62,0,0,0-.18,1.17,3.6,3.6,0,0,0,3.71,2.68,4.17,4.17,0,0,0,3.61-2.9,1.44,1.44,0,0,0-.16-1.19,1,1,0,0,0-1.13-.33,3.47,3.47,0,0,0-1.44,1.14,7.4,7.4,0,0,0-1.31,2.2,2.34,2.34,0,0,0-.21.91,11.84,11.84,0,0,1,1.8-2.86,3.47,3.47,0,0,1,1.29-1,.53.53,0,0,1,.61.18,1,1,0,0,1,.06.79,3.7,3.7,0,0,1-3.16,2.47A3.11,3.11,0,0,1,185.6,428a1.2,1.2,0,0,1,.09-.83.58.58,0,0,1,.6-.25,2.69,2.69,0,0,1,1.26.93A9.76,9.76,0,0,1,189.18,430.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111,253.63c-2.26-3.44-11.63,183.37-11,184.45l24.68.35,13.43-99.82,7.31-76.33L157.15,334,171.6,439.11l27,.38L181.9,249,147,229Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.52,128.12S127,129.44,124.07,132s-5.82,8.32-5.82,8.32L103.87,150l12.66,50.44-10.61,69.71,2.12,6,79.32-1.32,1.51-5.47L180.67,206l3.6-42.52,3.31-17.08-14.36-6.43s6.58-2,6.88-3.18-14.83-8.9-14.83-8.9S141.41,123.81,134.52,128.12Z",
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.45,237.45c9,11.59,21.17,20.14,33.2,28.5,2.54,1.76,5.17,3.57,8.2,4.16a11.49,11.49,0,0,0,11.54-4.84c1.74-2.65,2.33-6,4.39-8.4,1.4-1.63,3.35-2.68,4.85-4.22a20.84,20.84,0,0,0,3.11-4.59l4.92-8.88c-6,0-11.5,2.92-16.9,5.49s-11.39,4.91-17.21,3.58c-8.07-1.85-13.21-10.06-21-12.95a17.53,17.53,0,0,0-15,1.43",
    style: {
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.87,150s-3,3.77-3.61,11.69-5.76,49.48-4,55.45,23.93,30.9,31.33,30.29l2.76-1,2.64,2.05,11.82-8.86-26.05-32.79,1.4-47.2S112.11,148.17,103.87,150Z",
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.07,132s-.24.16-.65.54a11.69,11.69,0,0,0-1.59,1.88c-.64.88-1.28,2-2.07,3.41s-1.81,2.86-2.89,4.58l-.17-.21a7.32,7.32,0,0,1,4.87,0,17.11,17.11,0,0,1,4.91,2.69,46.3,46.3,0,0,1,8.84,9.51,195.93,195.93,0,0,1,16.25,27.41l0,.06v.07c-.12,4.12-.24,8.43-.37,12.83-.64,22.31-1.21,42.5-1.63,57.15-.23,7.29-.41,13.2-.54,17.31-.07,2-.13,3.61-.17,4.71,0,.52,0,.92-.06,1.22a2.7,2.7,0,0,1,0,.42,2.66,2.66,0,0,1,0-.42v-1.22c0-1.11.05-2.69.08-4.71.09-4.12.21-10,.37-17.32.35-14.63.81-34.83,1.48-57.15.13-4.4.25-8.72.37-12.84l0,.12A200.14,200.14,0,0,0,135,154.6a46.54,46.54,0,0,0-8.71-9.48,17.06,17.06,0,0,0-4.78-2.67,7,7,0,0,0-4.68,0l-.4.15.23-.35c1.1-1.7,2.09-3.22,2.94-4.55s1.48-2.51,2.14-3.38a10.41,10.41,0,0,1,1.66-1.84A3.27,3.27,0,0,1,124.07,132Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.37,138c0,.08-1.52.53-3.92,1.49a37.37,37.37,0,0,0-8.78,4.88,58,58,0,0,0-7.32,6.94l-2.07,2.27a5,5,0,0,1-.81.79,4.75,4.75,0,0,1,.66-.92c.44-.58,1.11-1.39,2-2.38a48.46,48.46,0,0,1,7.27-7.11,33.49,33.49,0,0,1,9-4.81c1.23-.45,2.24-.74,2.95-.93A4.06,4.06,0,0,1,177.37,138Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.52,182a7.54,7.54,0,0,1,.1-1.49c.11-.95.31-2.32.63-4,.62-3.36,1.73-8,3.2-13a115.44,115.44,0,0,1,4.45-12.59c.68-1.58,1.29-2.82,1.75-3.66a8.06,8.06,0,0,1,.79-1.26,8.57,8.57,0,0,1-.61,1.36c-.4.86-1,2.12-1.59,3.7-1.28,3.15-2.8,7.62-4.29,12.6s-2.63,9.55-3.34,12.89c-.36,1.66-.62,3-.79,3.95A9.27,9.27,0,0,1,151.52,182Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154,154.06a96.82,96.82,0,0,1,4.05-9,93.71,93.71,0,0,1,4.53-8.78,96,96,0,0,1-4.06,9A92.35,92.35,0,0,1,154,154.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.45,172.77l.23-.49a1.73,1.73,0,0,0,.94.31c.4,0,.56-.12.56-.3,0-.54-1.66-.19-1.65-1.26,0-.48.41-.88,1.22-.87a1.88,1.88,0,0,1,1,.27l-.21.5a1.64,1.64,0,0,0-.79-.24c-.39,0-.55.14-.55.32,0,.53,1.67.19,1.65,1.24,0,.48-.41.88-1.23.87A2,2,0,0,1,156.45,172.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.51,172.6v.53l-2.22,0,.05-2.87,2.16,0v.53l-1.5,0v.63h1.33v.52l-1.33,0v.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.86,171.7a1.49,1.49,0,0,1,1.58-1.46,1.45,1.45,0,0,1,1.17.53l-.43.38a.91.91,0,0,0-.71-.34.92.92,0,1,0,0,1.83.91.91,0,0,0,.72-.33l.42.4a1.45,1.45,0,0,1-1.19.49A1.47,1.47,0,0,1,161.86,171.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.16,172.35a3.31,3.31,0,0,1-.12-.42c0-.09-.07-.19-.1-.28v.27c0,.55-.25.77-.65.76s-.64-.23-.63-.78l0-1.58H165l0,1.61a1.2,1.2,0,0,0,1.28,1.33,1.27,1.27,0,0,0,1.07-.46A1.7,1.7,0,0,1,167.16,172.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.31,171l0,1,0,.1a2.09,2.09,0,0,1,.08.23l.09.36a3.07,3.07,0,0,1,.06.94,1.33,1.33,0,0,0,.39-1l0-1.61Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.4,174l-.54-.8h-.61v.8h-.66l0-2.87,1.24,0c.76,0,1.24.41,1.23,1.06a.92.92,0,0,1-.61.89l.63.93Zm-.59-2.33h-.54v1h.54c.4,0,.61-.18.62-.49S170.22,171.62,169.81,171.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.63,171.1h.66l0,2.87h-.66Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.56,171.67h-.92v-.54l2.49,0v.54h-.92l0,2.33h-.67Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.8,173l0,1h-.66v-1l-1.08-1.86h.71l.74,1.29.79-1.26h.65Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.64,180.5a2.71,2.71,0,0,1-.4-.75c-.22-.49-.51-1.23-.83-2.15a38.8,38.8,0,0,1-1.7-7.42,38.09,38.09,0,0,1-.21-7.6c.08-1,.18-1.76.27-2.3a2.34,2.34,0,0,1,.2-.82c.08,0,0,1.2-.1,3.13a47.27,47.27,0,0,0,1.89,14.9A30.68,30.68,0,0,1,169.64,180.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M153.47,172.54c-.42,3.56-1.56,5.32-1.62,8.9,0,.77-1.23,12.9-.51,13.17s4-8.5,4.75-12.9c.55-3.45,1.52-8,2.1-11.43,1.68-10.05,5.41-15.46,10.64-24.21,1-1.65,4.68-6.16,4.68-6.16-.35-.23-1.82.47-2.84.93-2.95,1.33-8.23,5.54-8.23,5.54a100.15,100.15,0,0,0-4.24,9.11,130.06,130.06,0,0,0-4.81,17.63"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M120.45,142s-3.22,1.76-3.2,3.18a4.14,4.14,0,0,0,2.34,3.31,30.75,30.75,0,0,0,4,1.48,23.38,23.38,0,0,1,8.09,5.77,68.56,68.56,0,0,1,10.08,12.92c2.35,3.9,4.5,8.25,8.43,10.55-2.66-4.76-5.42-9.37-8.08-14.13a91.29,91.29,0,0,0-9.19-13.45c-3.46-4.2-9.1-9.29-12.46-9.63"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M109,212.27a1,1,0,0,1,0-.26,4,4,0,0,1,0-.77,6,6,0,0,1,1-2.73,6,6,0,0,1,3.59-2.6,6.39,6.39,0,0,1,5.54,1.23l-.39.19a50.09,50.09,0,0,1,.6-10.07c.5-3.29,1.11-6.39,1.45-9.23a75.22,75.22,0,0,0,.59-7.6c.06-2.17,0-3.93,0-5.14,0-.56,0-1,0-1.4a1.56,1.56,0,0,1,0-.49,1.65,1.65,0,0,1,.07.48c0,.38.07.85.11,1.4.09,1.22.15,3,.14,5.16a67.86,67.86,0,0,1-.48,7.64c-.32,2.87-.91,6-1.42,9.26a52.44,52.44,0,0,0-.64,10l0,.53-.41-.34a6,6,0,0,0-5.14-1.21,5.74,5.74,0,0,0-3.45,2.38,6.22,6.22,0,0,0-1,2.59C109,211.91,109,212.27,109,212.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.49,236.64a1.83,1.83,0,0,1,.32.27c.22.23.51.51.87.86.78.73,1.92,1.81,3.46,3.06a51.48,51.48,0,0,0,5.83,4.11,23,23,0,0,0,3.87,1.95,5,5,0,0,0,2.23.33,3.3,3.3,0,0,0,2.06-.9l.15-.16.17.12c.83.65,1.73,1.34,2.65,2h-.29l11.81-8.87-.05.37-.21-.26c-3.56-4.44-6.74-8.82-9.69-12.75s-5.62-7.48-7.93-10.39-4.26-5.21-5.66-6.74c-.69-.77-1.26-1.35-1.64-1.74a4.19,4.19,0,0,1-.56-.62,4.74,4.74,0,0,1,.63.55c.41.36,1,.92,1.72,1.67,1.45,1.5,3.45,3.75,5.8,6.65s5.06,6.4,8,10.33,6.17,8.29,9.72,12.71l.2.26.17.21-.21.16-11.83,8.85-.15.11-.15-.11-2.64-2.06.33,0a3.74,3.74,0,0,1-2.38,1,5.37,5.37,0,0,1-2.41-.38,23.71,23.71,0,0,1-3.93-2A48.59,48.59,0,0,1,116,241a45.93,45.93,0,0,1-3.39-3.17l-.83-.9A1.76,1.76,0,0,1,111.49,236.64Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121,163.11c-.09,0-.47-1.15-1.44-2.89a20.27,20.27,0,0,0-1.94-2.89,23,23,0,0,0-3-3.05,23.79,23.79,0,0,0-3.53-2.38,21.5,21.5,0,0,0-3.19-1.39c-1.89-.63-3.13-.79-3.11-.89a2.94,2.94,0,0,1,.88,0,13.45,13.45,0,0,1,2.34.49,19.07,19.07,0,0,1,3.31,1.32,21.44,21.44,0,0,1,3.63,2.4,21.68,21.68,0,0,1,3,3.15,18.4,18.4,0,0,1,1.89,3,14.72,14.72,0,0,1,.91,2.22A3.09,3.09,0,0,1,121,163.11Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M168.72,178c.33.71,1.5.27,1.64-.29A2.41,2.41,0,0,0,170,176a30,30,0,0,1-3.29-11.57A28.61,28.61,0,0,0,168.72,178"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M108.55,211.22a6.58,6.58,0,0,1,3-7.53,3.85,3.85,0,0,1,2.14-.55c1.62.12,2.78,1.56,3.73,2.87a6.75,6.75,0,0,0-8.55,5.16"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M186.67,150.75a28.28,28.28,0,0,1-1.35,2.56,40.63,40.63,0,0,0-2.72,6.41,41.16,41.16,0,0,0-1.57,6.79,25.64,25.64,0,0,1-.42,2.87,11.86,11.86,0,0,1,0-2.92A32.42,32.42,0,0,1,185,153.13,11.49,11.49,0,0,1,186.67,150.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.06,176.14c-.53.55-.68,5.21-.68,5.21,0,5.63.36,8.1.37,13.72a25.88,25.88,0,0,1-.62,6.92,25.27,25.27,0,0,1-1.32,3.45,21.71,21.71,0,0,1-2.18,4.13,24.67,24.67,0,0,1-2.63,2.88,106.34,106.34,0,0,0-12.1,14.36L158.7,230l21.82-20.47,1.07-2.7.06-.32Z",
    style: {
      opacity: 0.3
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.58,146.36s3.44,1.3,5.23,9c2.07,8.86,4.78,23.58,5.2,29.16.35,4.69,5,21.83,1.39,29.38s-20.78,30.85-27.58,31.6l-2.84-.72-3,.51-8.35-9.62.73-2.75a2.75,2.75,0,0,1,0-2.9c1-1.37,22.3-21.39,22.3-21.39s-.82-.1-1-1.48c-.3-2.38,1.77-2.3,1.77-2.3l-1.38-20.95Z",
    style: {
      fill: "#6C2BD9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.87,211.08c-.09.13-1.66-1-3.89-1.7s-4.16-.73-4.16-.89a8,8,0,0,1,4.32.39A7.81,7.81,0,0,1,188.87,211.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.18,207.94a15.5,15.5,0,0,0-11.68-3.13,4.72,4.72,0,0,1,1.8-.46,12.17,12.17,0,0,1,8.55,2.29A4.61,4.61,0,0,1,193.18,207.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.82,208.49s-.35,0-.79-.3a1.69,1.69,0,0,1-.56-.8,2.18,2.18,0,0,1,0-1.19,2.63,2.63,0,0,1,.31-.73l0,.05a1.52,1.52,0,0,1,1.33-.89c.4,0,.61.09.6.15s-.22.06-.54.17a1.34,1.34,0,0,0-.91.73v0l0,0a3.26,3.26,0,0,0-.24.6,1.68,1.68,0,0,0,.32,1.59C180.58,208.26,180.86,208.42,180.82,208.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.85,175.12a4.82,4.82,0,0,1,.19,1.16c.09.75.19,1.84.29,3.18.22,2.69.43,6.41.61,10.52s.33,7.72.45,10.53c.05,1.26.09,2.33.12,3.19a5.31,5.31,0,0,1,0,1.17,4.82,4.82,0,0,1-.19-1.16c-.09-.75-.19-1.83-.29-3.18-.22-2.69-.42-6.41-.6-10.52s-.33-7.72-.45-10.53c-.05-1.26-.1-2.32-.13-3.19A5.31,5.31,0,0,1,179.85,175.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.17,208.35a4.54,4.54,0,0,1-.53.52l-1.58,1.42-5.85,5.31c-2.46,2.27-5.39,5-8.61,8.16-1.61,1.56-3.31,3.24-5,5a5.87,5.87,0,0,0-1.07,1.43,2.62,2.62,0,0,0-.18,1.71,9.57,9.57,0,0,1,.31,2,2,2,0,0,1-1.07,1.86l.1-.41c1.38,1.59,2.84,3.24,4.31,4.93l4.24,4.85L166,245l3-.51H169c1.3.16,2.39.76,3.52.57a6.62,6.62,0,0,0,3-1.4,47.68,47.68,0,0,0,4.77-4.45c2.87-3,5.21-5.87,7.14-8.26s3.43-4.36,4.47-5.69c.51-.64.9-1.15,1.2-1.53a3.7,3.7,0,0,1,.44-.51,3,3,0,0,1-.36.56l-1.13,1.58c-1,1.37-2.46,3.36-4.36,5.79s-4.22,5.32-7.08,8.36a46.72,46.72,0,0,1-4.8,4.54,7.08,7.08,0,0,1-3.27,1.5c-1.3.21-2.5-.44-3.63-.56H169l-3,.51-.15,0-.09-.11-4.24-4.84-4.31-4.94-.24-.28.34-.13a1.46,1.46,0,0,0,.75-1.39,9.21,9.21,0,0,0-.3-1.86,3.2,3.2,0,0,1,.23-2,6.32,6.32,0,0,1,1.17-1.55q2.63-2.64,5.07-5c3.25-3.13,6.2-5.85,8.7-8.09s4.54-4,6-5.19l1.64-1.35A3.89,3.89,0,0,1,181.17,208.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.66,196.34c0,.15-13.63.07-30.44-.17s-30.44-.56-30.44-.7,13.63-.07,30.45.18S180.66,196.2,180.66,196.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165,204.59a1.89,1.89,0,0,1,0,.39c0,.25-.07.62-.18,1.09a22.14,22.14,0,0,1-1.2,3.89,24,24,0,0,1-20.77,14.95,22.75,22.75,0,0,1-4.07-.1c-.48-.05-.84-.13-1.09-.17a1.25,1.25,0,0,1-.37-.1,44.17,44.17,0,0,0,5.5,0,24.49,24.49,0,0,0,20.46-14.73A45.69,45.69,0,0,0,165,204.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.84,246.38c-.09.11-.66-.21-1.18-.81s-.74-1.2-.62-1.28.53.38,1,.94S135.93,246.27,135.84,246.38Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.65,243.4c-.11.09-.54-.29-1-.85s-.66-1.09-.54-1.17.55.3,1,.86S139.77,243.32,139.65,243.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.77,235.39c.07.13-.5.54-1.22,1s-1.32.85-1.41.74.38-.67,1.12-1.17S161.71,235.26,161.77,235.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.61,238.17c.12.08-.23.84-1,1.55s-1.49,1.05-1.56.93.52-.63,1.19-1.3S164.49,238.09,164.61,238.17Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.33,241.5c.1.1-.34.74-1.08,1.32s-1.46.87-1.53.75.5-.6,1.21-1.16S167.22,241.4,167.33,241.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.53,135.07c.15-.06,1.34,3,3.38,6.35s4.1,5.89,4,6a8.09,8.09,0,0,1-1.48-1.53,34.53,34.53,0,0,1-2.94-4.2,32.87,32.87,0,0,1-2.29-4.59A7.49,7.49,0,0,1,128.53,135.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.87,269.41a7,7,0,0,1-.85,0l-2.42,0-8.91.08c-7.52.09-17.91.37-29.38.72s-21.88.58-29.4.57c-3.77,0-6.81,0-8.91-.08l-2.43-.07a4.6,4.6,0,0,1-.84-.06,5.5,5.5,0,0,1,.84-.05l2.43,0,8.9-.09c7.53-.09,17.91-.37,29.39-.72s21.87-.57,29.4-.57c3.76,0,6.81,0,8.91.08l2.42.08A4.67,4.67,0,0,1,188.87,269.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.67,247.21a2.21,2.21,0,0,0,2.1,1c.82,0,1.61-.3,2.42-.34a2.25,2.25,0,0,1,2.14.9,1.91,1.91,0,0,1-.06,1.85,3.76,3.76,0,0,1-1.41,1.3,7.61,7.61,0,0,1-8.64-.83",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.34,259.64a48.45,48.45,0,0,0,7.73,6.26,3.1,3.1,0,0,0,2,.69c.73-.12,1.3-1.07.82-1.62a2.25,2.25,0,0,0,2.66.07,2.28,2.28,0,0,0,.81-2.42.07.07,0,0,1,.09-.08,2.53,2.53,0,0,0,2.2-.15,1.89,1.89,0,0,0,.82-2.11c.74,1,2.52.61,3.09-.5a3.42,3.42,0,0,0-.58-3.5,17.34,17.34,0,0,0-2.77-2.5,5.52,5.52,0,0,1-2.08-3",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.24,265.39a5.35,5.35,0,0,1-2.63-1.7,5.25,5.25,0,0,1-1.67-2.65c.13-.07.85,1.1,2,2.29S154.32,265.25,154.24,265.39Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158,263.07a5.56,5.56,0,0,1-2.37-1.65,5.66,5.66,0,0,1-1.67-2.35c.13-.09.93.89,2,2S158.06,262.94,158,263.07Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.24,260.76a5,5,0,0,1-2.27-1.52,5.16,5.16,0,0,1-1.59-2.23c.12-.09.9.84,2,1.86S161.33,260.64,161.24,260.76Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.78,237s-.3-1.28,3-.87a37.71,37.71,0,0,0,8.44.54c3.69-.19,9.68-1.24,9.68-1.24l9.63,8.48s-9.85,8.65-12.8,10.19-8.94,5.38-12.36,5.2c-2.59-.14-2.82-1.43-2.82-1.43s-2.54-1.74-2.16-2.59c0,0-3-.17-2.44-2.47,0,0-2.15-.4-2.5-1.62s1.27-2.66,1.9-3.28c1-1,9.76-7.42,9.8-7.6C144.13,240.35,136.64,239.6,136.78,237Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143,246.39a25.54,25.54,0,0,1-3.94,3.36,26,26,0,0,1-4.25,3,25.25,25.25,0,0,1,3.94-3.37A26.83,26.83,0,0,1,143,246.39Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.63,247.29a6.12,6.12,0,0,1-1.15,1.57,25.59,25.59,0,0,1-7.37,5.76,6.06,6.06,0,0,1-1.8.73c-.08-.14,2.58-1.45,5.43-3.68S147.51,247.18,147.63,247.29Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.77,250.26a6.63,6.63,0,0,1-1.3,1.76,18.66,18.66,0,0,1-9,5.41,6.41,6.41,0,0,1-2.17.33,33.83,33.83,0,0,0,6.79-2.84A33.43,33.43,0,0,0,151.77,250.26Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.53,247.5a4.33,4.33,0,0,1-.73.75c-.49.46-1.22,1.1-2.15,1.85a63,63,0,0,1-7.7,5.32c-1.58.92-3.12,1.74-4.55,2.42a16,16,0,0,1-4,1.48,6.37,6.37,0,0,1-2.87,0,2.33,2.33,0,0,1-1-.42,7,7,0,0,0,3.75,0,17.83,17.83,0,0,0,3.84-1.55c1.4-.7,2.93-1.53,4.49-2.44a82.41,82.41,0,0,0,7.74-5.16C162.34,248.38,163.47,247.44,163.53,247.5Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.89,79.37a17.28,17.28,0,0,0-18.82,15.91c-.6,8-1.17,16.69-1.18,21.07,0,9.38,9.35,11,9.35,11s-.27,2.78-.58,6.23A12.36,12.36,0,0,0,146.23,147h0a12.34,12.34,0,0,0,13.08-11.6l2.24-37.78a17.28,17.28,0,0,0-15.66-18.24Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.23,127.19a21.79,21.79,0,0,0,12.28-3.3s-3.14,6.78-12.49,5.8Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.64,100.82c.16-.07,6.48-1.82,6.18,4.6s-6.67,4.79-6.68,4.6S160.64,100.82,160.64,100.82Z",
    style: {
      fill: "#b78876"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.21,107.69s.11.08.3.17a1.07,1.07,0,0,0,.83.06,2.79,2.79,0,0,0,1.4-2.42,3.82,3.82,0,0,0-.24-1.61,1.33,1.33,0,0,0-.8-.9.58.58,0,0,0-.68.28c-.09.17-.06.3-.09.31s-.13-.11-.07-.38a.71.71,0,0,1,.27-.39.87.87,0,0,1,.63-.13,1.59,1.59,0,0,1,1.12,1,3.78,3.78,0,0,1,.3,1.8,2.92,2.92,0,0,1-1.76,2.7,1.22,1.22,0,0,1-1-.22C162.22,107.84,162.19,107.7,162.21,107.69Z",
    style: {
      fill: "#aa6550"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.71,100.4a1.35,1.35,0,0,0,1.28,1.37,1.27,1.27,0,0,0,1.39-1.19,1.33,1.33,0,0,0-1.27-1.37A1.29,1.29,0,0,0,130.71,100.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.44,98.66c.16.18,1.19-.56,2.63-.53s2.49.76,2.65.58-.09-.39-.55-.73a3.59,3.59,0,0,0-2.11-.69,3.54,3.54,0,0,0-2.1.64C129.51,98.27,129.36,98.58,129.44,98.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.16,100.79a1.34,1.34,0,0,0,1.27,1.37,1.28,1.28,0,0,0,1.4-1.18,1.34,1.34,0,0,0-1.27-1.38A1.29,1.29,0,0,0,145.16,100.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.61,99.13c.16.18,1.19-.56,2.63-.53s2.49.76,2.65.59-.09-.4-.55-.74a3.64,3.64,0,0,0-2.11-.69,3.47,3.47,0,0,0-2.1.65C143.68,98.74,143.53,99.05,143.61,99.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.22,109.75a9.51,9.51,0,0,0-2.34-.45c-.36,0-.71-.12-.77-.38a1.91,1.91,0,0,1,.26-1.08l1.13-2.79c1.57-4,2.71-7.24,2.55-7.3s-1.56,3.1-3.13,7.07l-1.08,2.81a2.11,2.11,0,0,0-.22,1.44,1,1,0,0,0,.6.55,2.63,2.63,0,0,0,.63.1A8.66,8.66,0,0,0,138.22,109.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.94,93.91c.17.38,1.6.1,3.3.2s3.1.46,3.3.09c.09-.17-.18-.52-.75-.87a5.59,5.59,0,0,0-2.49-.69,5.49,5.49,0,0,0-2.53.47C142.16,93.4,141.87,93.73,141.94,93.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.9,93.35c.25.33,1.24,0,2.44,0s2.2.26,2.44-.08c.1-.17-.05-.5-.49-.81a3.52,3.52,0,0,0-3.93.06C128.93,92.85,128.79,93.19,128.9,93.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.38,100.53a11,11,0,0,1-.2,3.08,3.39,3.39,0,0,1-1.68,2.32c-1.62.78-3.62-.48-4.32-2.14s-.47-3.54-.28-5.34a25.79,25.79,0,0,0,0-7.34,10.52,10.52,0,0,0-3.43-6.35,6.7,6.7,0,0,0-6.9-1.09c-1.37.65-2.41,1.83-3.69,2.64a5.63,5.63,0,0,1-3.89.92c-1.35-.23-3.17-1.18-2.94-2.52.53-3.13-1.64-.5-1.5-1,.24-.88,2.05-2.41,2.8-3A10,10,0,0,1,139.65,79a22.43,22.43,0,0,1,12.25,1.39,15.89,15.89,0,0,1,8.72,8.34c1.8,4.42,1.52,7.1.91,11.86",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.27,114c0,.29-1.18.58-2.67.66s-2.72-.08-2.74-.37,1.19-.59,2.68-.67S141.26,113.73,141.27,114Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.36,101.1a6.73,6.73,0,0,1-2-.43c-1.19-.36-2.79-1-4.54-1.66l-4.46-1.8a8.71,8.71,0,0,1-1.85-.78,7.14,7.14,0,0,1,2,.43c1.19.36,2.79,1,4.54,1.66l4.46,1.8A8.45,8.45,0,0,1,161.36,101.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.68,95.56a1.92,1.92,0,0,1,1.68,1.59,8,8,0,0,1-5.84,8.95,4.65,4.65,0,0,1-3.66-.35c-1.49-.94-2-2.89-2.08-4.65a6,6,0,0,1,.64-3.74,5.39,5.39,0,0,1,4.32-2,49,49,0,0,1,4.94.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.22,95.79a1.93,1.93,0,0,0-1.74,1.57,8.07,8.07,0,0,0,5.64,9.21,4.73,4.73,0,0,0,3.71-.24c1.54-.92,2.06-2.88,2.24-4.65a6,6,0,0,0-.54-3.8,5.44,5.44,0,0,0-4.31-2.15c-1.66-.13-5,.06-5,.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.74,96.05a28.26,28.26,0,0,1-5.5.16,30.78,30.78,0,0,1-5.5-.37,28.33,28.33,0,0,1,5.51-.16A30.72,30.72,0,0,1,143.74,96.05Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161,138.61s0-.05,0-.15a2,2,0,0,1,0-.47,5.1,5.1,0,0,1,.62-1.66,11.69,11.69,0,0,0,1.13-2.49,12.71,12.71,0,0,0,.42-3.6c0-1.35-.17-2.81-.27-4.44a2.29,2.29,0,0,1,.31-1.3,1.22,1.22,0,0,1,1.31-.6,1,1,0,0,1,.64.49.79.79,0,0,1,0,.86,1.26,1.26,0,0,1-1.51.29,2.25,2.25,0,0,1-1.19-2.61,2.3,2.3,0,0,1,.89-1.3,1.59,1.59,0,0,1,.78-.31,1,1,0,0,1,.88.3.91.91,0,0,1,.22.95.93.93,0,0,1-.84.51,2.06,2.06,0,0,1-2.08-2.28,2.07,2.07,0,0,1,1-1.42,2,2,0,0,1,1.44-.26,1.43,1.43,0,0,1,.68.4.87.87,0,0,1,.23.83.89.89,0,0,1-.61.6,1.71,1.71,0,0,1-.74.06,2.58,2.58,0,0,1-1.26-.56,2.23,2.23,0,0,1-.82-2.46,2,2,0,0,1,2.16-1.27,1.19,1.19,0,0,1,1,1,.89.89,0,0,1-.27.71,1.15,1.15,0,0,1-.65.28,1.75,1.75,0,0,1-1.17-.43,2.75,2.75,0,0,1-.75-.91,1.69,1.69,0,0,1,.47-2.14,1.21,1.21,0,0,1,1.87.74l0,.14-.12.06a1.76,1.76,0,0,1-2.43-.87,1.49,1.49,0,0,1,.11-1.29,1.84,1.84,0,0,1,.9-.8,1.5,1.5,0,0,1,1.14,0,.85.85,0,0,1,.55.92.6.6,0,0,1-.36.44.76.76,0,0,1-.52,0,1,1,0,0,1-.54-.71,7.79,7.79,0,0,1,0-2.37,3.34,3.34,0,0,1,.17-.81,12.07,12.07,0,0,0,.08,3.12.73.73,0,0,0,.41.53.34.34,0,0,0,.5-.23c.11-.51-.73-.83-1.28-.54a1.32,1.32,0,0,0-.79,1.64,1.38,1.38,0,0,0,1.87.66l-.1.2a.8.8,0,0,0-1.22-.43,1.24,1.24,0,0,0-.29,1.58,1.87,1.87,0,0,0,1.46,1.07c.27,0,.52-.25.48-.47a.73.73,0,0,0-.59-.54,1.46,1.46,0,0,0-1.58,1,1.71,1.71,0,0,0,.67,1.88,2.15,2.15,0,0,0,1,.45c.34,0,.74-.07.78-.29s-.21-.51-.54-.58a1.4,1.4,0,0,0-1,.2,1.51,1.51,0,0,0-.73,1,1.44,1.44,0,0,0,.4,1.19,1.48,1.48,0,0,0,1.13.5c.43,0,.52-.31.28-.6s-.68-.17-1,.07a1.87,1.87,0,0,0-.7,1,1.78,1.78,0,0,0,.9,2c.33.15.79.11.93-.11s0-.57-.35-.65a.79.79,0,0,0-.82.41,1.81,1.81,0,0,0-.25,1c.08,1.57.23,3.09.21,4.46a12.69,12.69,0,0,1-.52,3.67,10.11,10.11,0,0,1-1.23,2.51,5.4,5.4,0,0,0-.69,1.58C161,138.4,161,138.61,161,138.61Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.68,107.92a3.52,3.52,0,0,0-.42-1.38,1.64,1.64,0,0,0-1.16-.79,1.26,1.26,0,0,0-1.27.81,1.31,1.31,0,0,0,.47,1.42l0,0h0l.11.08c.17.1.41.12.57.22a1.15,1.15,0,0,1,.44,1.07,12.09,12.09,0,0,0-.09,1.21c0,.29.19.63.48.64s.44-.25.54-.48A5.11,5.11,0,0,0,164.68,107.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.1,128.84s-2,2.94-2.18,4.86c-.11,1.27.74,6.2,1.32,9.39a13.41,13.41,0,0,0,2.1,5.11l1.3,1.91a44.54,44.54,0,0,1,4.68,8.81c2.54,6.42,6.8,17.22,7,17.73a40.48,40.48,0,0,0,1.89,3.77l2.26-26.95,6.8-13.48a9.16,9.16,0,0,0,1-3.77l.16-4.32a6.11,6.11,0,0,0-1.58-4.31h0l-.34,3.9-11.27,10.24-13.09-8.8Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.58,141.82a6.79,6.79,0,0,0-2.36,2.22,25.21,25.21,0,0,0-2.73,7.46c-.08.3-.15.6-.22.88l-.1.4-.32-.27a50.26,50.26,0,0,1-5.29-5.28,19,19,0,0,1-1.95-2.34,17.4,17.4,0,0,1,2.21,2.1,73.9,73.9,0,0,0,5.36,5.12l-.42.14.22-.88c.75-3.05,1.68-5.83,2.94-7.54a5.65,5.65,0,0,1,1.81-1.7A2,2,0,0,1,147.58,141.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.63,149.08a30.71,30.71,0,0,1-2.54,4.13l-.41.62v-.76a15.4,15.4,0,0,0-.7-3.66,20.3,20.3,0,0,0-2-5.68,15.55,15.55,0,0,0-1.6-1.9s.23.08.6.34a6,6,0,0,1,1.31,1.35,17.57,17.57,0,0,1,2.2,5.75,13.81,13.81,0,0,1,.66,3.81l-.42-.14A31.09,31.09,0,0,1,155.63,149.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.47,178.58c-.14,0-.78-8.16-1.43-18.25s-1.06-18.27-.92-18.28.79,8.16,1.44,18.25S150.61,178.57,150.47,178.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.27,101.11a2.57,2.57,0,0,1-.12-2.35c.43-1.31,1.44-1.93,1.5-1.81s-.64.83-1,2S125.42,101.08,125.27,101.11Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.77,101.67c-.11.09-.77-.76-.76-2s.65-2.12.76-2-.25.92-.24,2S141.9,101.6,141.77,101.67Z",
    style: {
      fill: "#e0e0e0"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityPana);
export default __webpack_public_path__ + "static/media/security-pana.2e1fb83b.svg";
export { ForwardRef as ReactComponent };